/**
 * Daisi Backend API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

// @ts-ignore
import { PushSubscriptionDto } from '../model/push-subscription-dto';
// @ts-ignore
import { UserStateDto } from '../model/user-state-dto';
import { Param } from '../param';
import { ApiConfigurationService } from '../../helpers/api-configuration.service';
import { HttpParamHelper } from '../../helpers/http-param-helper';
import { CustomHttpParameterCodec } from '../encoder';

import { COLLECTION_FORMATS } from '../variables';

@Injectable({
  providedIn: 'root',
})
export class UserStateControllerService {
  private readonly encoder: CustomHttpParameterCodec;
  private readonly httpClient = inject(HttpClient);
  protected readonly configuration = inject(ApiConfigurationService);

  constructor() {
    this.encoder = this.configuration.encoder;
  }

  public addPushSubscription(
    pushSubscriptionDto: PushSubscriptionDto,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public addPushSubscription(
    pushSubscriptionDto: PushSubscriptionDto,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public addPushSubscription(
    pushSubscriptionDto: PushSubscriptionDto,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public addPushSubscription(
    pushSubscriptionDto: PushSubscriptionDto,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (pushSubscriptionDto === null || pushSubscriptionDto === undefined) {
      throw new Error(
        'Required parameter pushSubscriptionDto was null or undefined when calling addPushSubscription.',
      );
    }
    return this.httpClient.request<any>('post', `/api/user/push-subscription`, {
      body: pushSubscriptionDto,
      observe: observe,
    });
  }

  public getUserState(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<UserStateDto>;
  public getUserState(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<UserStateDto>>;
  public getUserState(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<UserStateDto>>;
  public getUserState(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: '*/*'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    return this.httpClient.request<UserStateDto>('get', `/api/user/state`, {
      responseType: '*/*'.startsWith('text/') ? ('text' as 'json') : undefined,
      observe: observe,
    });
  }

  public setUserState(
    userStateDto: UserStateDto,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public setUserState(
    userStateDto: UserStateDto,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public setUserState(
    userStateDto: UserStateDto,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public setUserState(
    userStateDto: UserStateDto,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (userStateDto === null || userStateDto === undefined) {
      throw new Error(
        'Required parameter userStateDto was null or undefined when calling setUserState.',
      );
    }
    return this.httpClient.request<any>('put', `/api/user/state`, {
      body: userStateDto,
      observe: observe,
    });
  }
}
